module.exports = __webpack_public_path__ + "img/icon4.da4a03f2.png";